// extracted by mini-css-extract-plugin
export default {"text":"Avatar_text__zoaI3"};